import React from 'react'
import PropTypes from 'prop-types'
import { CMSContent, Columns, ExpandableContent, Image, Media, MediaQuery, ThemeProvider, Title } from '@deseretbook/react-ui'

/**
 * Displays the name, bio and image of an author if available
 *
 * @returns {function} Component
 */
const AuthorBio = ({ author, imageSrc }) =>
  (
    <ThemeProvider>
      <MediaQuery.Medium>
        {isMediumOrLarger => (
          <Columns isCentered>
            <Columns.Column size={{ medium: 8 }}>
              <Media>
                {
                  author.icon_file_name
                    ? (
                      <Media.Figure
                        size={
                          isMediumOrLarger
                            ? 'medium'
                            : 'small'
                        }
                      >
                        <Image
                          ratio="1x1"
                          src={imageSrc}
                          alt={author.name}
                          isRounded
                        />
                      </Media.Figure>
                    )
                    : null
                }
                <Media.Content>
                  <Title
                    title={author.name}
                    subtitle={
                      author.meta_title
                      ? author.meta_title
                      : null
                    }
                  />
                  {
                    isMediumOrLarger
                      ? (
                        <ExpandableContent collapsedHeight={3}>
                          <CMSContent
                            itsNotDangerousBecause="html is from Solidus admin"
                            dangerouslySetInnerHTML={{ __html: author.description }}
                          />
                        </ExpandableContent>
                      )
                      : null
                  }
                </Media.Content>
              </Media>
              {
                !isMediumOrLarger
                  ? (
                    <ExpandableContent collapsedHeight={3}>
                      <CMSContent
                        itsNotDangerousBecause="html is from Solidus admin"
                        dangerouslySetInnerHTML={{ __html: author.description }}
                      />
                    </ExpandableContent>
                  )
                  : null
              }
            </Columns.Column>
          </Columns>
        )}
      </MediaQuery.Medium>
    </ThemeProvider>
  )

AuthorBio.propTypes = {
  author: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    description: PropTypes.string,
    icon_file_name: PropTypes.string,
    meta_title: PropTypes.string,
  }),
  imageSrc: PropTypes.string,
}

AuthorBio.defaultProps = {
  author: {},
  imageSrc: '',
}

export default AuthorBio
